import { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { toast } from "sonner";

export default function BridalAppointment() {
  const { settings, loading } = useSite();
  const b = settings.home.bridal;
  const [form, setForm] = useState({ name: "", phone: "", email: "", event_date: "", city: "", message: "" });
  const [busy, setBusy] = useState(false);
  const setF = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => { e.preventDefault(); setBusy(true); try { await api.post("/appointments", form); toast.success("Appointment requested", { description: "Our atelier will reach you within 24 hours." }); setForm({ name: "", phone: "", email: "", event_date: "", city: "", message: "" }); } catch (e) { toast.error(formatErr(e)); } setBusy(false); };
  return (
    <section id="bridal" className="relative py-24 md:py-32 bg-sand/60" data-testid="bridal-appointment">
      <div className="container-lux grid md:grid-cols-2 gap-16 items-center">
        <div className="relative aspect-[4/5] overflow-hidden bg-muted">
          {loading || !b.image ? <div className="absolute inset-0 bg-muted animate-pulse" data-testid="bridal-image-loading" /> : <img src={b.image} alt="Bridal appointment" className="w-full h-full object-cover" loading="lazy" />}
        </div>
        <div>
          <p className="overline text-muted-foreground">{b.kicker}</p><h2 className="mt-6 font-serif tracking-tighter text-5xl md:text-6xl font-light leading-[0.95]">{b.title_line1}<br/><em className="not-italic">{b.title_line2}</em></h2>
          <p className="mt-6 text-sm text-muted-foreground max-w-md whitespace-pre-line">{b.description}</p>
          <form onSubmit={submit} className="mt-10 grid grid-cols-2 gap-x-8 gap-y-2">
            <FormField label="Name" testid="apt-name" value={form.name} onChange={setF("name")} required /><FormField label="Phone" testid="apt-phone" value={form.phone} onChange={setF("phone")} required />
            <FormField label="Email" testid="apt-email" type="email" value={form.email} onChange={setF("email")} required /><FormField label="Event Date" testid="apt-date" type="date" value={form.event_date} onChange={setF("event_date")} required />
            <FormField label="City" testid="apt-city" value={form.city} onChange={setF("city")} required className="col-span-2" /><FormField label="Message" testid="apt-message" value={form.message} onChange={setF("message")} className="col-span-2" />
            <button type="submit" disabled={busy} data-testid="apt-submit" className="lux-btn-dark col-span-2 mt-6">{busy ? "…" : "Book Appointment"}</button>
          </form>
        </div>
      </div>
    </section>
  );
}
function FormField({ label, testid, className = "", ...rest }) {
  return (
    <div className={className}>
      <label className="overline text-muted-foreground">{label}</label>
      <input className="lux-input" data-testid={testid} {...rest} />
    </div>
  );
}
